{
  "name": "registrator",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "node generate-build-info.js && ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:dev": "node generate-build-info.js && ng build --configuration development",
    "build:prod": "node generate-build-info.js && ng build --configuration production",
    "build:test": "node generate-build-info.js && ng build --configuration test",
    "prestart": "node generate-build-info.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.1",
    "@angular/cdk": "^20.2.0",
    "@angular/common": "^20.2.1",
    "@angular/compiler": "^20.2.1",
    "@angular/core": "^20.2.1",
    "@angular/forms": "^20.2.1",
    "@angular/material": "^20.2.0",
    "@angular/material-luxon-adapter": "^20.2.2",
    "@angular/platform-browser": "^20.2.1",
    "@angular/platform-browser-dynamic": "^20.2.1",
    "@angular/router": "^20.2.1",
    "@types/node": "^22.14.0",
    "bootstrap": "^5.3.3",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.2.0",
    "@angular/cli": "^20.2.0",
    "@angular/compiler-cli": "^20.2.1",
    "@types/jasmine": "~5.1.0",
    "@types/luxon": "^3.7.1",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^20.2.0",
    "typescript": "~5.9.2"
  }
}
